
import * as icons from '@mdi/js'
import LandingList from '@/components/landing/LandingList.vue'

export default {
  components: { LandingList },
  props: {
    column: {
      type: Object,
      required: true
    },
    columnItems: {
      type: Array,
      default: () => []
    }
  },
  icons
}
